import {
  FetchResponseError,
  addMessageToExsistingFetchError,
} from 'utils/errors/customError';
import { buildPath, httpGet, httpPost } from 'utils/http';

import {
  DeltakerUtsendingEstimertAntallDto,
  UtsendingEstimatForEnhetDto,
  UtsendingTypeMedEstimatDto,
} from './dto';
import {
  GetEstimertAntallForUtsendingTyper,
  GetEstimertAntallPerUtsendingstypeId,
  GetEstimertAntallPerUtsendingstypeIdEnhet,
  GetUtsendingTypeById,
  PostUtsendingstyperAlleTilgjengelige,
  PostUtsendingstyperPerType,
  UtsendingerService,
} from './interface';

export const getUtsendingTypeById: GetUtsendingTypeById = async (
  id,
  params?,
  signal?
) => {
  const fullPath = buildPath(`utsendingstyper/${id}`, params);

  return httpGet(fullPath, signal).catch((error: FetchResponseError) => {
    throw addMessageToExsistingFetchError(
      error,
      `En feil oppsto i henting av utsendingType id ${id}, følgende feilmelding ble returnert: ${error.message}`
    );
  });
};

export const postUtsendingstyperAlleTilgjengelige: PostUtsendingstyperAlleTilgjengelige =
  async (tilOgMedDato) => {
    const fullPath = buildPath(
      `deltakerutsendingoppdrag/alle-tilgjengelige-typer`
    );
    try {
      return await httpPost<{
        tilOgMedDato: string;
      }>(fullPath, {
        tilOgMedDato,
      });
    } catch (err) {
      const newError = err as FetchResponseError;
      newError.message = `${newError.message}`;
      throw newError;
    }
  };
export const postUtsendingstyperPerType: PostUtsendingstyperPerType = async (
  body
) => {
  const fullPath = buildPath(`deltakerutsendingoppdrag/typer`);
  try {
    return await httpPost(fullPath, body);
  } catch (err) {
    throw err;
  }
};

export const getEstimertAntallPerUtsendingstypeId: GetEstimertAntallPerUtsendingstypeId =
  async (utsendingstypeId, tilOgMedDato, signal) => {
    const fullPath = buildPath(
      `utsendingstyper/${utsendingstypeId}/estimert-antall`,
      { tilOgMedDato }
    );
    try {
      return await httpGet<DeltakerUtsendingEstimertAntallDto>(
        fullPath,
        signal
      );
    } catch (err) {
      const newError = err as FetchResponseError;
      throw addMessageToExsistingFetchError(
        newError,
        `henting av estimat feilet for utsendingstypeId: ${utsendingstypeId} ${newError.message}`
      );
    }
  };

export const getEstimertAntallPerUtsendingstypeIdEnhet: GetEstimertAntallPerUtsendingstypeIdEnhet =
  async (tilOgMedDato, utsendingstypeId, signal) => {
    if (!!!tilOgMedDato) return new Promise((resolve) => resolve([]));
    const fullPath = buildPath(
      `utsendingstyper/${utsendingstypeId}/estimert-antall-per-enhet?tilOgMedDato=${tilOgMedDato}`
    );

    try {
      if (!utsendingstypeId) return new Promise((resolve) => resolve([]));
      return await httpGet<UtsendingEstimatForEnhetDto[]>(fullPath, signal);
    } catch (err) {
      const newError = err as FetchResponseError;
      throw addMessageToExsistingFetchError(
        newError,
        `henting av estimat feilet for utsendingstypeId: ${utsendingstypeId} ${newError.message}`
      );
    }
  };

export const getEstimertAntallForUtsendingTyper: GetEstimertAntallForUtsendingTyper =
  async (signal) => {
    const fullPath = buildPath(
      'utsendingstyper/manuelt-initierte-estimert-antall'
    );
    try {
      return await httpGet<UtsendingTypeMedEstimatDto[]>(fullPath, signal);
    } catch (err) {
      const newError = err as FetchResponseError;
      throw addMessageToExsistingFetchError(
        newError,
        `henting av estimat for alle utsendingstyper feilet:  ${newError.message}`
      );
    }
  };

export default {
  getUtsendingTypeById,
  getEstimertAntallForUtsendingTyper,
  getEstimertAntallPerUtsendingstypeId,
  getEstimertAntallPerUtsendingstypeIdEnhet,
  postUtsendingstyperAlleTilgjengelige,
  postUtsendingstyperPerType,
} as UtsendingerService;
